import { createContext, useContext, useState, ReactNode } from 'react';
import { NewPlayerContextType } from './newPlayerContext.type';
import { PlayerUpdate } from '@inplay/models';
import { SelectPlayerOption } from '../../component/addNewPlayerModal/addNewPlayerModal.type';

const NewPlayerContext = createContext<NewPlayerContextType | undefined>(
  undefined,
);

export const NewPlayerProvider = ({ children }: { children: ReactNode }) => {
  const [newPlayers, setNewPlayers] = useState<PlayerUpdate[]>([]);
  const [selectedOption, setSelectedOption] = useState<SelectPlayerOption>(
    SelectPlayerOption.Random,
  );

  const addNewPlayer = (player: PlayerUpdate) => {
    setNewPlayers((previousPlayer) => {
      const exists: boolean = previousPlayer.some(
        (previousPlayer: PlayerUpdate) => previousPlayer.id === player.id,
      );
      if (exists) return previousPlayer;
      return [...previousPlayer, player];
    });
  };

  const updateExistingPlayer = (
    originalId: string,
    updatedPlayer: PlayerUpdate,
  ) => {
    setNewPlayers((previousPlayer) =>
      previousPlayer.map((player: PlayerUpdate) =>
        player.id === originalId ? updatedPlayer : player,
      ),
    );
  };

  const removeNewPlayer = (playerId: string) => {
    setNewPlayers((previousPlayer) =>
      previousPlayer.filter((player: PlayerUpdate) => player.id !== playerId),
    );
  };

  return (
    <NewPlayerContext.Provider
      value={{
        newPlayers,
        setNewPlayers,
        removeNewPlayer,
        selectedOption,
        setSelectedOption,
        addNewPlayer,
        updateExistingPlayer,
      }}
    >
      {children}
    </NewPlayerContext.Provider>
  );
};

export const useNewPlayers = () => {
  const context = useContext(NewPlayerContext);
  if (!context) {
    throw new Error('useNewPlayers must be used within a NewPlayerProvider');
  }
  return context;
};
